import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { CopyAddAssetState } from '../../../types/Assets/AssetList/addEditListTypes'
import { AllAssetsList } from '../../../types/Assets/AssetList/AssetListTypes'
import { RootState } from '../../../stateStore'
import AddAssetApi from '../../../middleware/api/Assets/AssetList/AddEditAssetListApi'
import { ValidationError } from '../../../types/commonTypes'

export const initialCopyAddAssetSliceState: CopyAddAssetState = {
  copyAddAssetObject: {} as AllAssetsList,
}

export const DefaultAssetValues: AllAssetsList = {
  id: 0,
  poNumber: '',
  vendorId: 0,
  productSpecificationId: 0,
  manufacturerId: '',
  productId: 0,
  pSpecification: '',
  productName: '',
  manufacturerName: '',
  assetNumber: '',
  otherAssetNumber: '',
  invoiceNumber: '',
  purchasedDate: '',
  receivedDate: '',
  notes: '',
  employeeName: '',
  employeeId: 0,
  description: '',
  status: '',
  assetTypeId: 0,
  assetType: '',
  productSpecification: '',
  otherNumber: '',
  warrantyStartDate: '',
  warrantyEndDate: '',
  searchByEmpName: '',
  departmentId: 0,
  departmentName: '',
  location: '',
  vendorName: '',
  createdBy: '',
  updatedBy: '',
  createdDate: '',
  updatedDate: '',
  referenceNumber: '',
  amount: '',
  countryId: 0,
}

const copyAddAssetThunk = createAsyncThunk(
  'copAddAsset/getCopyAssetList',
  async (id: number, thunkApi) => {
    try {
      return await AddAssetApi.getCopyAssetList(id)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const CopyAddAssetSlice = createSlice({
  name: 'CopyAddAssetSlice',
  initialState: initialCopyAddAssetSliceState,
  reducers: {
    setCopyAddAssetObject: (state, action) => {
      state.copyAddAssetObject = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(copyAddAssetThunk.fulfilled, (state, action) => {
      state.copyAddAssetObject = action.payload
    })
  },
})

const getCopyAddAssetObject = (state: RootState): AllAssetsList =>
  state.copyAddAsset.copyAddAssetObject

export const CopyAddAssetThunk = {
  copyAddAssetThunk,
}

export const CopyAddAssetSelector = {
  getCopyAddAssetObject,
}

export const CopyAddAssetService = {
  ...CopyAddAssetThunk,
  actions: CopyAddAssetSlice.actions,
  selectors: CopyAddAssetSelector,
}

export default CopyAddAssetSlice.reducer
